module.exports = __webpack_public_path__ + "static/media/chalkboard-teacher.4b8b9358.svg";